import { InputType } from "@app/enum/input-type";
import { QuestionBase } from "../question-base";

export class RadioQuestion extends QuestionBase<string> {
  override type = InputType.RADIO;
}